import React, { useState, useEffect } from 'react';
import ReactTable from "react-table";
import "react-table/react-table.css";
import matchSorter from 'match-sorter';
import { useHistory } from 'react-router-dom';
import { notificarError, notificarMsg } from '../Almacenes/AlmacenNotify';
import { convertStrToJson, doDownload, GUIA_REMISION_TRANSPORTISTA } from '../../Global';
import jsPDF from "jspdf";
import { getLoadImage, loadLogoByRUC } from '../../helpers/funcionesGlobales';
import {Style, Section} from "../../pages/RegistroVentas/ClasesImpresion";
import moment from 'moment';
import QRCode from "qrcode";


function Lista() {
    const history = useHistory();
    const [guias, setGuias] = useState([]);
    const [infoSucursal, setInfoSucursal] = useState({});
    const [ubigeos, setUbigeos] = useState([]);

    useEffect(() => {
        getGuias();
        getInfoSucursal();
        fetchUbigeos();
    }, []);

    const fetchUbigeos = async () => {
        try {
            const req = await fetch(`/api/clientes/ubigeos`);

            if (!req.ok) {
                notificarError('No se pudieron obtener los ubigeos.');
                return;
            }

            const data = await req.json();
            setUbigeos(data.results);
        } catch (error) {
            notificarError('Error al cargar los ubigeos.');
        }
    }

    const getInfoSucursal = async () => {
        try {
            const response = await fetch(`/api/guiaRemision/InfoEmpresa`);
            const data = await response.json();
            setInfoSucursal(data);
        } catch (error) {
            console.error(error);
        }
    }

    const getGuias = async () => {
        const response = await fetch('/api/guias-remision-transportista/');
        const data = await response.json();
        setGuias(data);
    }

    const getUbigeo = (codUbigeo) => {
        const codRegion = codUbigeo.slice(0, 2);
        const codProvincia = codUbigeo.slice(2, 4);
        const codDistrito = codUbigeo.slice(4, 6);

        const region = ubigeos.find(ubigeo => ubigeo.CodRegion === codRegion && ubigeo.CodProvincia === "00" && ubigeo.CodDistrito === "00");
        const provincia = ubigeos.find(ubigeo => ubigeo.CodRegion === codRegion && ubigeo.CodProvincia === codProvincia && ubigeo.CodDistrito === "00");
        const distrito = ubigeos.find(ubigeo => ubigeo.CodRegion === codRegion && ubigeo.CodProvincia === codProvincia && ubigeo.CodDistrito === codDistrito);

        return {
            region: region.NombreUbigeo,
            provincia: provincia.NombreUbigeo,
            distrito: distrito.NombreUbigeo,
        }
    }

    const sendGuiaSunatVerifica = async (guia) => {
        const {SunatTicket, serie, correlativo} = guia
        const serieCorrelativo = serie + '-' + correlativo;

        const url = `/api/guias-remision-transportista/check-guia/${SunatTicket}/${serieCorrelativo}?idGuia=${guia.IdGuiaRemisionTransportista}`;
        const res = await fetch(url);

        if (!res.ok) {
            notificarError("Hubo un error al verificar la guia, , asegurese que el envio es correcto")
            return;
        }

        notificarMsg("Se ha verificado con éxito la guía de remisión.")
        getGuias();
    }

    const sendGuiaSunat = async (guia) => {
        const url = `/api/guias-remision-transportista/send/${guia.IdGuiaRemisionTransportista}`;
        const response = await fetch(url);

        if (!response.ok) {
            notificarError("Error al enviar la guía. Intente nuevamente.");
            return;
        }

        const data = await response.json();

        
        if (data.ok) {
            notificarMsg("Se ha enviado la guía con éxito.");
            getGuias();
        } else {
            notificarError("Error al enviar la guía. Intente nuevamente.");
        }

    }

    const getGuia = async (idGuia) => {
        const url = `/api/guias-remision-transportista/guiaPorId/${idGuia}`;
        const response = await fetch(url);
        const data = await response.json();
        return data;
    }

    const obtenerSunatPdf = async (idGuia) => {
        const response = await fetch(`/api/guias-remision-transportista/sunat-pdf/${idGuia}`);

        if (!response.ok) {
            return null;
        }

        const data = await response.json();
        return data.documentDescription;
    }

    const obtenerFacturadorPdf = async (guia) => {
        const req = await fetch('/api/guiaRemision/facturador-file-url', {
            method: 'POST',
            body: JSON.stringify({
                tipoDoc: `${GUIA_REMISION_TRANSPORTISTA}`.padStart(2, '0'),
                serie: guia.serie,
                correlativo: guia.correlativo
            }),
            headers: {
                'Content-Type': 'application/json'
            }
        })

        if (!req.ok) {
            return null;
        }

        const data = await req.json();

        if (!('url' in data)) {
            return null;
        }

        return data['url'];
    }

    const handleSavePDFitem = async (idGuia) => {
        const data = await getGuia(idGuia);

        let x = 7
        let y = 32

        let logoP = await loadLogoByRUC(infoSucursal[0].Ruc, "logo", infoSucursal[1]);
        let logo = await logoP;

        const guia = data.guia;
        const items = data.dets.map((item, index) => ({
            ...item,
            Indice: index + 1,
            Unidad: item.unidad,
            Cantidad: item.Cantidad,
        }));
        const nombreArchivo = guia.serie + "-" + guia.correlativo.toString().padStart(6, '0');

        let doc = new jsPDF({});

        doc.addImage(logo, "JPEG", 5, 5, 60, 15);

        const pageHeight =
            doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
        const pageWidth =
            doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
        
        doc.setFontSize(13);
        doc.setFontType("normal");
        doc.text(`    R.U.C. ${infoSucursal[0].Ruc}`, 141, 12);

        doc.setFontSize(13);
        doc.setFontType("bold");
        doc.text("    GUÍA DE REMISION", 141, 17);
        doc.text("TRANSPORTISTA", 148, 22);

        doc.setFontType("bold");
        doc.setFontSize(14);
        doc.text(
            `         ${guia.serie + " - Nº " + guia.correlativo}`,
            141,
            27
        );

        doc.setFontSize(7);
        doc.setFontType("normal");
        let EmpresaTittleStyle = new Style(7, "", 1.5);
        let EmpresaTittleSection = new Section(
            doc,
            x,
            23,
            EmpresaTittleStyle,
            130
        );
        EmpresaTittleSection.write(`${infoSucursal[0].Nombre}: ${infoSucursal[0].Direccion}`, EmpresaTittleStyle);
        y = y + 3
        //Empiezo a manejar el style y section
        EmpresaTittleStyle = new Style(8, "normal", 1.5);
        EmpresaTittleSection = new Section(
            doc,
            x,
            y,
            EmpresaTittleStyle,
            0
        );
        // doc.rect(x-1, y-3, 41, 9)
        // doc.rect(x+45 , y-3, 55, 9)
        EmpresaTittleSection.write("FECHA DE                                               FECHA DE INICIO ", EmpresaTittleStyle);
        EmpresaTittleSection.write("EMISION                                                  DE TRASLADO", EmpresaTittleStyle);

        EmpresaTittleStyle = new Style(11, "", 1.5);
        EmpresaTittleSection = new Section(
            doc,
            x + 17,
            y + 3,
            EmpresaTittleStyle,
            0
        );
        EmpresaTittleSection.write(`${moment(guia.FechaEmision).format("DD/MM/YYYY")}                                        ${moment(guia.FechaInicioTraslado).format("DD/MM/YYYY")}`, EmpresaTittleStyle);
        //eMPIEZAN LOS DATOS DOMICILIO PARTIDA LLEGADA DESTINATARIO Y UNIDAD DE TRANSPORTE
        x = x - 1
        y = y + 9
        //Cuadrados con una linea separadora -> domicilio de partida, llegada
        doc.rect(x, y, 93, 27)
        doc.line(x, y + 6, x + 93, y + 6)
        doc.rect(x + 99, y, 93, 27)
        doc.line(x + 99, y + 6, x + 99 + 93, y + 6)

        y = y - 3
        let DomicilioStyle = new Style(11, "bold", 1.5);
        let DomicilioSection = new Section(
            doc,
            x + 20,
            y + 4,
            DomicilioStyle,
            0
        );
        DomicilioSection.write("   PUNTO DE PARTIDA                                                                  PUNTO DE LLEGADA", DomicilioStyle)
        DomicilioStyle = new Style(9, "", 1.5);
        DomicilioSection = new Section(
            doc,
            x + 2,
            y + 10,
            DomicilioStyle,
            80
        );

        DomicilioSection.write(`DIRECCION: ${guia.direccionRemitente}`, DomicilioStyle)
        const ubigeoRemitente = getUbigeo(guia.codUbigeoRemitente);
        DomicilioSection.write(`DISTRITO: ${ubigeoRemitente.distrito.toUpperCase()} PROV.: ${ubigeoRemitente.provincia.toUpperCase()} DEP.: ${ubigeoRemitente.region.toUpperCase()}`, DomicilioStyle)

        DomicilioStyle = new Style(9, "", 1.5);
        DomicilioSection = new Section(
            doc,
            x + 101,
            y + 10,
            DomicilioStyle,
            80
        );

        DomicilioSection.write(`DIRECCION: ${guia.direccionDestinatario}`, DomicilioStyle)
        const ubigeoDestinatario = getUbigeo(guia.codUbigeoDestinatario);
        DomicilioSection.write(`DISTRITO: ${ubigeoDestinatario.distrito.toUpperCase()} PROV.: ${ubigeoDestinatario.provincia.toUpperCase()} DEP.: ${ubigeoDestinatario.region.toUpperCase()}`, DomicilioStyle)

        y = y + 33;

        doc.rect(x, y, 93, 20)
        doc.line(x, y + 6, x + 93, y + 6)

        doc.rect(x + 99, y, 93, 20)
        doc.line(x + 99, y + 6, x + 99 + 93, y + 6)

        y = y - 3
        let destinatarioTransporteStyle = new Style(11, "bold", 1.5);
        let destinatarioTransporteSection = new Section(
            doc,
            x + 20,
            y + 4,
            destinatarioTransporteStyle,
            0
        );

        destinatarioTransporteSection.write(`            REMITENTE                                                                                DESTINATARIO`, destinatarioTransporteStyle)

        destinatarioTransporteStyle = new Style(9, "", 1.5);
        destinatarioTransporteSection = new Section(
            doc,
            x + 2,
            y + 10,
            destinatarioTransporteStyle,
            90
        );

        destinatarioTransporteSection.write(`RAZON SOCIAL: ${guia.razonSocialRemitente}`, destinatarioTransporteStyle)
        destinatarioTransporteSection.write(`RUC: ${guia.numeroDocRemitente} `, destinatarioTransporteStyle)

        destinatarioTransporteStyle = new Style(9, "", 1.5);
        destinatarioTransporteSection = new Section(
            doc,
            x + 101,
            y + 10,
            destinatarioTransporteStyle,
            80
        );

        destinatarioTransporteSection.write(`RAZON SOCIAL: ${guia.razonSocialDestinatario}`, destinatarioTransporteStyle)
        destinatarioTransporteSection.write(`RUC: ${guia.numeroDocDestinatario} `, destinatarioTransporteStyle)

        y = y + 27

        let TransporteStyle = new Style(9, "bold", 1.5);
        let TransporteSection = new Section(
            doc,
            x + 2,
            y + 5,
            TransporteStyle,
            0
        );

        // TransporteSection.write(`      CODIGO                                            DESCRIPCION                                                   CANTIDAD            UNID. DE MED.        PESO`, TransporteStyle)
        //AQUI VAN LOS PRODUCTOS
        const startYTabla = Math.max(TransporteSection.y, TransporteSection.y);
        doc.setFontSize(8);
        doc.autoTable({
            body: items,
            bodyStyles: {fontSize: 7},
            headStyles: {fontSize: 8},
            startY: y,
            margin: {
                right: 12,
                left: 6,
                bottom: 10
            },
            columnStyles: {
                NombreProducto: {columnWidth: 60},
                PrecioVenta: {halign: 'right'},
                Importe: {halign: 'right'},
            },
            styles: {
                overflow: "linebreak",
                lineWidth: 0.1,
                tableWidth: "auto",
                columnWidth: "auto",
                halign: "center"
            },
            PageBreak: "avoid",
            columns: [
                {header: "ITEM", dataKey: "Indice"},
                {header: "DESCRIPCIÓN", dataKey: "descripcion"},
                {header: "CANTIDAD", dataKey: "Cantidad"},
                {header: "MEDIDA", dataKey: "Unidad"},
            ],
            theme: "plain"
        });

        let finalTable = doc.autoTable.previous.finalY;
        let PiePagStyle = new Style(9, "bold", 1.5);
        let PiePagSection = new Section(
            doc,
            160,
            finalTable + 4,
            PiePagStyle,
            60
        );
        PiePagSection.write(`PESO: ${guia.Peso} Kg`, PiePagStyle)

        y = finalTable + 2
        doc.rect(x, pageHeight - 56, 93, 25)
        doc.line(x, pageHeight - 50, x + 93, pageHeight - 50)

        const facturadorFileUrl = await obtenerFacturadorPdf(data.guia);

        if (!!facturadorFileUrl) {
            const qr = await QRCode.toDataURL(facturadorFileUrl, { margin: 1.7 });
            const imgQR = await getLoadImage(qr);
            
            doc.setFontSize(8);
            doc.setFontType("normal");
            doc.text("MI FACTURA PERÚ", 12, pageHeight - 94);
            doc.addImage(imgQR, "PNG", 6, pageHeight - 93, 38, 38);
        }

        const sunatPdf = await obtenerSunatPdf(idGuia)

        if (!!sunatPdf) {
            const qr = await QRCode.toDataURL(sunatPdf, { margin: 0 });
            const imgQR = await getLoadImage(qr);

            doc.setFontSize(8);
            doc.setFontType("normal");
            doc.text("SUNAT", 60, pageHeight - 94);
            doc.addImage(imgQR, "PNG", 49, pageHeight - 92, 35, 35);
        }

        PiePagStyle = new Style(9, "bold", 1.5);
        PiePagSection = new Section(
            doc,
            x + 2,
            pageHeight - 54,
            PiePagStyle,
            0
        );
        PiePagSection.write(`                 UNIDAD DE TRANSPORTE Y CONDUCTOR`, PiePagStyle)

        PiePagStyle = new Style(7, "", 1.5);
        PiePagSection = new Section(
            doc,
            x + 2,
            pageHeight - 47,
            PiePagStyle,
            93
        );
        PiePagSection.write(`VEHICULO MARCA Y PLACA Nº: ${guia.Vehiculo || ""}`.toUpperCase(), PiePagStyle)

        PiePagSection = new Section(
            doc,
            x + 2,
            pageHeight - 42,
            PiePagStyle,
            93
        );

        PiePagSection.write(`LICENCIA CONDUCTOR 1 Nº: ${guia.NumeroLicencia || ""}`, PiePagStyle)

        const blob = doc.output('blob');

        const formData = new FormData();
        formData.append('pdf', blob);
        formData.append('tipoDoc', `${GUIA_REMISION_TRANSPORTISTA}`.padStart(2, '0'));
        formData.append('serie', guia.serie);
        formData.append('correlativo', guia.correlativo);

        await fetch('/api/guias-remision-transportista/subir-pdf', {
            method: 'POST',
            body: formData
        })

        doc.save(nombreArchivo + ".pdf");
    }

    const handleNewGuia = () => {
        history.push('/guia-remision-transportista/0');
    }

    const sendWhatsApp = async (guia) => {
        let numeroCelular = prompt("Por favor, ingrese el número de celular (solo dígitos):");
        if (!numeroCelular || !/^\d{9}$/.test(numeroCelular)) {
            alert("Debe ingresar un número de celular válido.");
            return;
        }

        let resEnvioOp = convertStrToJson(guia.resOperador);
        let xml = resEnvioOp.xmlFirmado ? resEnvioOp.xmlFirmado : null;
        let cdrZip = resEnvioOp.cdrZip ? resEnvioOp.cdrZip : null;

        const facturadorFileUrl = await obtenerFacturadorPdf(guia)
        const facturadorText = facturadorFileUrl ? `*FACTURADOR*%F0%9F%93%91%3A%20${facturadorFileUrl}` : ""

        const sunatPdf = await obtenerSunatPdf(guia.IdGuiaRemisionTransportista)
        const sunatText = sunatPdf ? `*SUNAT*%F0%9F%93%91%3A%20${sunatPdf}` : ""

        const url = `https://web.whatsapp.com/send?phone=${numeroCelular}&text=*_HTTPS://WWW.MIFACTURAPERU.COM_*%0A%0A%20*GUÍA*%20*DE*%20*REMISIÓN*%20*TRANSPORTISTA*%F0%9F%A7%BE%0A%0A*XML*%F0%9F%93%91%3A%20${xml}%0A*CDR*%F0%9F%93%91%3A%20${cdrZip}%0A${sunatText}%0A${facturadorText}%0A%0A*WWW.MIFACTURAPERU.COM*`

        window.open(url, "_blank")
    }

    return <section className='ventas-fpay-section-vh' style={{height: '100vh'}}>
        <div className="container pt-5">
            <div className="row mb-3">
                <div className="col-12 text-start" align="left">
                    <button title="Nueva Guía de Remisión" className="ml-3 btn btn-verde-mfp mb-2" onClick={handleNewGuia}>
                        Nueva guía
                    </button>
                </div>
                <div className="col-12">
                <ReactTable
                    data={guias}
                    filterable
                    defaultFilterMethod={(filter, row) =>
                        String(row[filter.id]) === filter.value}
                    columns={[
                        {
                            columns: [
                                {
                                    Header: "Acciones",
                                    accessor: "Editar",
                                    maxWidth: 500,
                                    minWidth: 150,
                                    width: 450,
                                    wrap: true,
                                    filterable: false,
                                    Cell: (f) => {
                                        let resEnvioOp = convertStrToJson(f.original.resOperador);
                                        let xml = resEnvioOp.xmlFirmado ? resEnvioOp.xmlFirmado : null;
                                        let cdrZip = resEnvioOp.cdrZip ? resEnvioOp.cdrZip : null;
                                        
                                        return <div>
                                            <button
                                                className="btn btn-primary btn-sm ml-1"
                                                title="Enviar a Operador"
                                                disabled={resEnvioOp.ok}
                                                onClick={() => sendGuiaSunat(f.original)}
                                            >
                                                ENVIAR
                                            </button>

                                            <button
                                                title="Guardar PDF"
                                                className="btn btn-danger btn-sm ml-1"
                                                onClick={() => handleSavePDFitem(f.original.IdGuiaRemisionTransportista)}
                                            >
                                                PDF
                                            </button>

                                            {f.original.SunatTicket ? (
                                                <button
                                                    className="btn btn-info btn-sm ml-1"
                                                    title="Verificar"
                                                    disabled={f.original.Cdr ? true : false}
                                                    onClick={() => sendGuiaSunatVerifica(f.original)}
                                                >
                                                    VERIFICAR
                                                </button>
                                            ) : null}

                                            {f.original.Cdr ? (
                                                <a
                                                    className="btn btn-info btn-sm  ml-1 "
                                                    target="blank"
                                                    href={f.original.Cdr}
                                                    title={`Descargar CDR`}
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        let url = f.original.Cdr.replace("http://", "https://")
                                                        window.open(url, "_blank")
                                                    }}
                                                >
                                                    CDR
                                                </a>
                                            ) : null}

                                            {xml ? (
                                                <a
                                                    className="btn btn-success btn-sm ml-1 "
                                                    target="blank"
                                                    href={xml}
                                                    title={`Descargar XML`}
                                                    onClick={e => {
                                                        e.preventDefault();
                                                        doDownload(xml, xml.substring(xml.lastIndexOf("/") + 1, xml.length))
                                                    }}
                                                >
                                                    XML
                                                </a>
                                            ) : null}

                                            {f.original.Cdr ? (
                                                <button
                                                    className="btn btn-success btn-sm ml-1"
                                                    title="Enviar a WhatsApp"
                                                    onClick={() => sendWhatsApp(f.original)}
                                                >
                                                    WhatsApp
                                                </button>
                                            ) : null}
                                        </div>
                                    }
                                },
                                {
                                    Header: "Serie",
                                    id: "serie",
                                    width: 120,
                                    accessor: d => d.serie,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, {keys: ["serie"]}),
                                },
                                {
                                    Header: "Correlativo",
                                    id: "correlativo",
                                    width: 120,
                                    accessor: d => d.correlativo.toString().padStart(6, '0'),
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, {keys: ["correlativo"]}),
                                },
                                {
                                    Header: "Fecha Emisión",
                                    id: "fechaEmision",
                                    width: 120,
                                    accessor: d => d.fechaEmision,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, {keys: ["fechaEmision"]}),
                                    filterAll: true
                                },
                                {
                                    Header: "Fecha Traslado",
                                    id: "fechaTraslado",
                                    width: 120,
                                    accessor: d => d.fechaTraslado,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, {keys: ["fechaTraslado"]}),
                                    filterAll: true
                                },
                                {
                                    Header: "Remitente",
                                    id: "razonSocialRemitente",
                                    width: 280,
                                    accessor: d => d.razonSocialRemitente,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, {keys: ["razonSocialRemitente"]}),
                                    filterAll: true
                                },
                                {
                                    Header: "Destinatario",
                                    id: "razonSocialDestinatario",
                                    width: 280,
                                    accessor: d => d.razonSocialDestinatario,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, {keys: ["razonSocialDestinatario"]}),
                                    filterAll: true
                                },
                                {
                                    Header: "Peso",
                                    id: "Peso",
                                    width: 80,
                                    accessor: d => `${d.Peso} Kg`,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, {keys: ["Peso"]}),
                                    filterAll: true
                                },
                                {
                                    Header: "Observaciones",
                                    id: "observaciones",
                                    width: 150,
                                    accessor: d => d.observaciones,
                                    filterMethod: (filter, rows) =>
                                        matchSorter(rows, filter.value, {keys: ["observaciones"]}),
                                    filterAll: true
                                },
                            ]
                        },
                    ]}
                    defaultPageSize={5}
                    className="-striped -highlight"
                    previousText='Anterior'
                    nextText='Siguiente'
                    loadingText='Cargando...'
                    noDataText='No se encontraron registros'
                    pageText='Página'
                    ofText='de'
                    rowsText='filas'
                    pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                />
                </div>
            </div>
        </div>
    </section>
}

export default Lista;
